import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@/components/ui/card.tsx';
import { cn } from 'cn';
import { ReactNode } from 'react';

type ContentCardProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  title?: string;
  headerAction?: ReactNode;
  onClick?: () => void;
};

export function ContentCard({
  children,
  className,
  contentClassName,
  title,
  headerAction,
  onClick,
}: ContentCardProps) {
  return (
    <Card
      size="sm"
      className={cn(
        'mb-3 shadow-sm',
        onClick && 'cursor-pointer transition-opacity active:opacity-85',
        className,
      )}
      onClick={onClick}
    >
      {title ? (
        <CardHeader className="pb-2">
          <CardTitle>{title}</CardTitle>
          {headerAction ? <CardAction>{headerAction}</CardAction> : null}
        </CardHeader>
      ) : null}
      <CardContent
        className={cn('flex flex-col gap-2', !title && 'pt-4', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  );
}
